import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ServiceDto } from '../models/servicedto';
import { AppConfigService } from './core/appConfig.service';

@Injectable({
  providedIn: 'root'
})
export class ServicesService {

  private url_all_services = '';
  private url_create_service = '';
  private url_update_service = '';
  private url_delete_service = '';



  constructor(private http: HttpClient, private configService: AppConfigService) {
    this.url_all_services = this.configService.apiUrl + '/configuration/service/listAll?page=1&sizePage=10&orderField=codeService&order=1';
    this.url_create_service = this.configService.apiUrl + '/configuration/service/insert';
    this.url_update_service = this.configService.apiUrl + '/configuration/service/update/true';
    this.url_delete_service = this.configService.apiUrl + '/configuration/service/delete/';
  }

  getAllServices(): Observable<any> {
    return this.http.get<any>(this.url_all_services);
  }

  createService(service: ServiceDto): Observable<any> {
    return this.http.post<any>(this.url_create_service, service);
  }

  updateService(service: ServiceDto): Observable<any> {
    return this.http.put<any>(this.url_update_service, service);
  }

  deleteService(serviceCode: number | null) {
    return this.http.delete<any>(this.url_delete_service + serviceCode);
  }
}
